import { render, staticRenderFns } from "./CompaniesPlans.vue?vue&type=template&id=ba0719de&scoped=true&"
import script from "./CompaniesPlans.vue?vue&type=script&lang=js&"
export * from "./CompaniesPlans.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesPlans.vue?vue&type=style&index=0&id=ba0719de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0719de",
  null
  
)

export default component.exports